/** Hinweis in der Glocke, wenn das Push-Abo verloren ging (F-31). */
import { useState } from 'react';

import { pushEinschalten, usePush } from '@/modules/benachrichtigungen/push/client';

export function PushHinweis() {
  const zustand = usePush((s) => s.zustand);
  const [fehler, setFehler] = useState<string | null>(null);
  if (zustand !== 'verloren' && zustand !== 'blockiert') return null;
  return (
    <div role="status" className="border-b border-line bg-danger/10 px-4 py-2 text-[12px]">
      {zustand === 'verloren' ? (
        <>
          Push-Benachrichtigungen kommen auf diesem Gerät nicht mehr an – das Abo ist verloren gegangen.{' '}
          <button type="button" className="font-medium text-accent-text hover:underline"
            onClick={() => void pushEinschalten().catch((e: Error) => setFehler(e.message))}>Neu anmelden</button>
        </>
      ) : 'Benachrichtigungen sind für diese Seite im Browser blockiert. Erlaube sie in den Website-Einstellungen, um Push zu nutzen.'}
      {fehler && <p className="mt-1 text-danger">{fehler}</p>}
    </div>
  );
}
